import React from 'react'
import { Link } from 'react-router-dom'
import { Container, Row, Col, Card, CardBody, Table, Button } from 'reactstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPencil, faTrash } from '@fortawesome/pro-duotone-svg-icons'
import {
  useAllQuery,
  usePrefetchAll,
} from '../../utils/hooks/reactQuery/queries'
import NewItemButton from '../../components/NewItemButton'
import { toast } from 'react-toastify'
import { useConfirmActionModal } from '../../utils/contexts/confimActionModalContext'
import { useItemMutation } from '../../utils/hooks/reactQuery/mutations'

export default function IterableTemplates() {
  const {
    data: templates = [],
    isLoading,
    isError,
    error,
  } = useAllQuery('iterable-templates')

  const { setConfirmActionModal } = useConfirmActionModal()
  const { _delete } = useItemMutation('iterable-template')

  // Prefetch
  usePrefetchAll('iterable-message-types')
  usePrefetchAll('iterable-data-feeds')

  const popTemplatesTable = (templates) => {
    return templates.map((template) => (
      <tr key={template.templateId}>
        <td className="align-middle">{template.name}</td>
        <td className="align-middle">{template.creatorUserId}</td>
        <td className="align-middle text-start">
          {new Date(template.createdAt).toLocaleString([], {
            day: 'numeric',
            year: 'numeric',
            month: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
          })}
        </td>
        <td className="align-middle text-start">
          {new Date(template.updatedAt).toLocaleString([], {
            day: 'numeric',
            year: 'numeric',
            month: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
          })}
        </td>
        <td className="align-middle">
          <Link to={`${template.templateId}`} className="text-decoration-none">
            <Button
              color="cpblue-500"
              className="rounded-circle d-block mx-auto"
            >
              <FontAwesomeIcon icon={faPencil} />
            </Button>
          </Link>
        </td>
        <td className="align-middle">
          <Button
            color="cpred-500"
            className="rounded-circle d-block mx-auto"
            onClick={() =>
              setConfirmActionModal({
                open: true,
                title: 'Confirm Delete?',
                severity: 'warning',
                message: `Are you sure you'd like to delete ${template.name}?`,
                onClose: (confirmed) => {
                  if (confirmed) {
                    const toastId = toast.loading(
                      `Deleting ${template.name}...`,
                    )
                    _delete.mutate(template.templateId, {
                      onSuccess: () => {
                        toast.update(toastId, {
                          render: `Deleted ${template.name}!`,
                          type: 'success',
                          isLoading: false,
                          autoClose: 1500,
                        })
                      },
                      onError: (error) => {
                        console.error(error)
                        toast.update(toastId, {
                          render: 'Error deleting...',
                          type: 'error',
                          isLoading: false,
                          autoClose: 1500,
                        })
                      },
                    })
                  }
                },
              })
            }
          >
            <FontAwesomeIcon icon={faTrash} />
          </Button>
        </td>
      </tr>
    ))
  }

  return (
    <Container fluid>
      <Row>
        <Col>
          <h1>Iterable Template Files</h1>
          <p>Create, Delete, and Update Iterable Template Files here.</p>
        </Col>
      </Row>
      <Row>
        <Col>
          <NewItemButton text="Add Iterable Template" />
        </Col>
      </Row>
      <Row className="pt-3">
        <Col>
          {isLoading ? (
            <h5>Loading...</h5>
          ) : isError ? (
            <h5>Error: {error.message}</h5>
          ) : (
            <>
              <Card className="rounded shadow border-0">
                <CardBody>
                  <Table borderless striped responsive>
                    <thead>
                      <tr>
                        <th>Template Name</th>
                        <th>Modified By</th>
                        <th className="text-start">Created At</th>
                        <th className="text-start">Modified At</th>
                        <th className="text-center">Edit</th>
                      </tr>
                    </thead>
                    <tbody>{popTemplatesTable(templates)}</tbody>
                  </Table>
                </CardBody>
              </Card>
            </>
          )}
        </Col>
      </Row>
    </Container>
  )
}
